module.exports = __webpack_public_path__ + "img/1567133522.ff7a9d2d.jpg";